import { styled, withStaticProperties } from "@tamagui/core";
import { View } from "../primitives/View.mjs";
import { GroupButton } from "./Group.Button";
import { GroupContext } from "./Group.context";
const GroupContainer = styled(View, {
    context: GroupContext,
    defaultVariants: {
      layout: "column",
      reverse: !1
    },
    justifyContent: "space-between",
    name: "GroupContainer",
    variants: {
      layout: {
        column: {
          flexDirection: "column",
          gap: "$group.verticalGap"
        },
        row: {
          alignItems: "center",
          flexDirection: "row",
          gap: "$group.horizontalGap"
        }
      },
      reverse: {
        ":boolean": (v, {
          props
        }) => {
          if (v && "layout" in props) {
            if (props.layout === "row") return {
              flexDirection: "row-reverse"
            };
            if (props.layout === "column") return {
              flexDirection: "column-reverse"
            };
          }
          return {};
        }
      }
    }
  }),
  Group = withStaticProperties(GroupContainer, {
    Button: GroupButton,
    Props: GroupContext.Provider
  });
Group.displayName = "Group";
export { Group };
//# sourceMappingURL=Group.mjs.map
